<!-- 由 suu 创建于 2022-09-15 星期四 -->
<template>
  <div class="dy-wx-h5">
    <div class="dy-btn" @click="handleClick"></div>
    <img :src="bgImg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'dy-wx-h5',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {
    bgImg() {
      return (
        this.$route.query.bgImg ||
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dy-xfc-wx-bg'
      )
    },
    wxUrl() {
      return (
        this.$route.query.wxUrl ||
        'https://work.weixin.qq.com/kfid/kfce17d1daa940a53ba'
      )
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handleClick() {
      location.href = this.wxUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.dy-wx-h5 {
  min-height: 100vh;
  background-color: #ede5ff;
  position: relative;
  .dy-btn {
    width: 170px;
    height: 52px;
    position: absolute;
    left: 16px;
    top: 151px;
    // background: #f00;
  }
  img {
    width: 100vw;
  }
}
</style>
